import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-hold',
  templateUrl: './icon-hold.component.html',
  styleUrls: ['./icon-hold.component.scss']
})
export class IconHoldComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
